import {remote} from '../constants/environment';
import {IDebtorItem} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {IDebtorListResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IPortfolioFilter} from '../context/commons/interfaces';

export const getClientDebtorsList = async (
  key: string,
  token: string,
  filter?: IPortfolioFilter | null,
): Promise<IDebtorListResponse> => {
  const remoteURI = remote.getClientDebtorsListUri(key);
  const body = filter
    ? {
        body: JSON.stringify({
          payload: filter ?? null,
        }),
      }
    : {};

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: filter ? 'POST' : 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        ...body,
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as IDebtorItem[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IDebtorListResponse;
};
